import { Fragment, useState, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'

// components
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

import { resolveToolIcon } from '@aytm/app/stats/page/question-views/components/lib/tool-meta'

// styles
import style from '@aytm/app/stats/page/question-views/components/questions-custom/styles/Controls.module.scss'

const Controls = ({ children, model, data, collapsed, onToggle }) => {
  const [status, setStatus] = useState('')

  const icon = resolveToolIcon(model?.type, model?.insightsMapping)

  const timer = useRef(null)

  const toggle = useCallback(() => {
    setStatus('toggling')
    onToggle()

    timer.current && clearTimeout(timer.current)
    timer.current = setTimeout(() => 'toggling' === status && setStatus(''), 500)

    return () => timer.current && clearTimeout(timer.current)
  }, [status, onToggle])

  return (
    <div className={style.component}>
      {icon && (
        <div className={style.icon}>
          <i className={icon.className} />
          <span>
            {icon.words.map((word, index) => (
              <Fragment key={word}>
                {0 < index && <br />}
                {word}
              </Fragment>
            ))}
          </span>
        </div>
      )}
      <div className={`${style.controls} p-right p-col`}>{children}</div>
      <div className={`${style.options} p-right`}>
        <div
          className={`${style.toggle} ${
            'toggling' == status ? (collapsed ? style['toggle-spin-reverse'] : style['toggle-spin']) : ''
          }`}
        >
          <i
            data-testid={`stat-dl-controls-toggle-${model?.id}`}
            data-collapsed={collapsed}
            className="icon-aytmfd-config"
            aria-label="Settings"
            aria-expanded={!collapsed}
            {...pressable(toggle)}
          />
        </div>
        {data.help && (
          <div className={style.help}>
            <Popup
              width="500px"
              trigger="click"
              direction="bottomright"
              popupOffset={9}
              hideOtherPopupsOnShow
              content={() => <div dangerouslySetInnerHTML={{ __html: data.help }}></div>}
            >
              <i className="icon-aytmfd-help-v2" />
            </Popup>
          </div>
        )}
      </div>
    </div>
  )
}

Controls.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  collapsed: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.any
}

Controls.displayName = 'Controls'

export default Controls
